module.exports = __webpack_public_path__ + "static/media/ec11.36f2aa4e.jpg";